import { Box, getThemeColor, getThemeSpacing } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
`

export const InformationContainer = styled(Box)`
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(300px, 1fr);

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`

export const TagContainer = styled(Box)<{ status: 'pending' | 'complete' }>`
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 300;

  ${({ theme, status }) => {
    if (status === 'pending') {
      return `
        background-color: ${getThemeColor('warning', theme)}33;
        color: ${getThemeColor('warning', theme)};
        border: 1px solid ${getThemeColor('warning', theme)};
      `
    }
    return `
        background-color: ${getThemeColor('success', theme)}33;
        color: ${getThemeColor('success', theme)};
        border: 1px solid ${getThemeColor('success', theme)};
      `
  }}
`
